import { HelpTooltip } from '#/components/v2/help-tooltip';
import { useTranslation } from '#/contexts/useTranslation';
import useParamsLocale from '#/data/useParamsLocale';
import useEthereumPendingQueueInfo from '#/data/v2/useEthereumPendingQueueInfo';
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  formatDuration,
  minutesToMilliseconds,
} from 'date-fns';
import { useMemo } from 'react';

export function WithdrawalQueueLength() {
  const locale = useParamsLocale();
  const { data: pendingQueueData, isLoading } = useEthereumPendingQueueInfo();
  const withdrawalQueueMs = useMemo(() => {
    const withdrawalQueueM = pendingQueueData?.data.data?.withdrawalQueue ?? 0;
    return minutesToMilliseconds(withdrawalQueueM);
  }, [pendingQueueData]);
  const withdrawalQueueText = useMemo(
    () =>
      formatDuration(
        {
          days: differenceInDays(withdrawalQueueMs, 0),
          hours: differenceInHours(withdrawalQueueMs, 0) % 24,
          minutes: differenceInMinutes(withdrawalQueueMs, 0) % 60,
        },
        { locale }
      ),
    [withdrawalQueueMs, locale]
  );
  return isLoading ? '-' : withdrawalQueueText;
}
export function WithdrawalQueueTip() {
  const translation = useTranslation(
    translation => translation.EthereumStaking
  );
  return (
    <div className="flex flex-col gap-1">
      <div className="capitalize text-gray-500 font-normal text-sm">
        {translation.WithdrawalQueueLabel}{' '}
        <HelpTooltip content={translation.WithdrawalQueueLabelHelp} />
      </div>
      <div className="flex gap-2 items-center">
        <dt className="capitalize text-gray-500 font-normal text-sm">
          {translation.WithdrawalQueueLength}{' '}
          <HelpTooltip content={translation.WithdrawalQueueLengthHelp} />
        </dt>
        <dd className="text-base text-gray-800 font-medium">
          <WithdrawalQueueLength />
        </dd>
      </div>
    </div>
  );
}
